import apiClient from "./billingServiceClient";

export const fetchSubscriptionDetails = async () => {
  const response = await apiClient.get("/subscriptions");
  return response.data;
};

export const createSubscription = async ({ priceId, quantity }) => {
  const payload = {
    priceId,
    quantity,
  };

  const response = await apiClient.post("/subscriptions", payload);
  return response.data;
};

export const fetchPaymentStatus = async (paymentId) => {
  if (!paymentId) {
    throw new Error("paymentId is required");
  }

  const response = await apiClient.get(
    `/payments/${encodeURIComponent(paymentId)}/status`
  );
  return response.data;
};

export const fetchActiveSubscriptionStatus = async () => {
  const response = await apiClient.get("/subscriptions/active");
  return response.data;
};

export const cancelSubscription = async (subscriptionId) => {
  if (!subscriptionId) {
    throw new Error("subscriptionId is required");
  }

  const payload = {
    subscriptionId,
  };

  const response = await apiClient.post("/subscriptions/cancel", payload);
  return response.data;
};

export default {
  fetchSubscriptionDetails,
  createSubscription,
  fetchPaymentStatus,
  fetchActiveSubscriptionStatus,
  cancelSubscription,
};
